@import '../../../theme.scss';

verdocs-template-field-properties {
  padding: 20px;
  display: block;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #ccc;
  font-family: $verdocs-primary-font;
  box-shadow: 2px 2px 10px 0 #0000001f;

  @media all and (max-width: 600px) {
    padding: 10px;
    transform: scale(0.8);
  }

  .buttons {
    display: flex;
    margin-top: 30px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;

    verdocs-button {
      margin-left: 16px;
    }
  }

  form .row {
    display: flex;
    column-gap: 15px;
    margin: 0 0 10px 0;
    align-items: center;
    flex-direction: row;

    .input-label {
      display: block;
      color: $label-color-light;
      font-weight: 700;
      font-size: 14px;
      margin: 0 0 4px 0;
      flex: 0 0 100px;
    }
  }

  verdocs-select-input {
    flex: 1;
    margin: 0;
  }

  verdocs-text-input {
    margin: 0;
    flex: 1;

    label {
      margin: 0;
      display: flex;
      column-gap: 15px;
      align-items: center;
      flex-direction: row;
    }

    .input-label {
      flex: 0 0 100px;
    }

    input {
      flex: 1;
      display: flex;
    }
  }

  .checkbox-wrapper {
    flex: 1;
    display: flex;
  }

  .delete-button {
    height: 34px;
    display: flex;
    cursor: pointer;
    background: none;
    border-radius: 4px;
    align-items: center;
    border: 1px solid #999;
    justify-content: center;

    &:active {
      background: #f3f3f3;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }

  h6 {
    flex: 1;
    display: flex;
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 8px 0;
    flex-direction: row;
    color: $verdocs-grey-0;

    .help-icon {
      opacity: 0.5;

      &:hover {
        opacity: 1;
        cursor: pointer;
      }
    }
  }

  .instructions {
  }

  .row-header {
    gap: 15px;
    display: flex;
    flex-direction: row;

    h6 {
      margin-bottom: 0;
    }

    verdocs-help-icon {
      transform: scale(0.85);

      svg {
        margin-bottom: -5px;
      }
    }

    .add-button {
      margin: 0;
      padding: 0;
      border: none;
      opacity: 0.5;
      cursor: pointer;
      background: none;

      &:hover {
        opacity: 1;
      }

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }

  .options-header {
    gap: 10px;
    margin: 0 0 5px 0;
    display: flex;
    color: #ffffff;
    font-size: 14px;
    padding: 5px 8px;
    font-weight: 700;
    text-align: center;
    flex-direction: row;
    justify-content: center;
    background-color: #333333;
  }

  .options-header-label {
    display: flex;
    flex: 1;
    font-weight: 700;
    font-size: 14px;
  }

  .option-row {
    margin: 15px 0;

    .remove-button {
      height: 28px;
      display: flex;
      cursor: pointer;
      background: none;
      border-radius: 4px;
      align-items: center;
      border: 1px solid #999;
      justify-content: center;

      &:active {
        background: #f3f3f3;
      }

      &:hover {
        svg {
          stroke: rgb(165, 0, 33);
        }
      }

      svg {
        width: 20px;
        height: 20px;
        stroke: #333333;
      }
    }
  }

  .options {
    background: #f3f3f3;
    padding: 0 0 1px 0;

    .row-header,
    .option-row {
      padding: 0 10px;
    }

    .add-option-button {
      border-radius: 5px;
      border: 1px solid #cccccc;
      background: $verdocs-grey-blue;
      color: #ffffff;
      padding: 3px 8px;
    }

    .option-row .input-element {
      font-size: 14px;
    }

    verdocs-help-icon {
      opacity: 1;
      transform: scale(0.8);

      svg {
        fill: #ffffff;
      }
    }
  }
}
